// import * as AiIcons from 'react-icons/ai'; // Ant Design Icons
// import * as BsIcons from 'react-icons/bs'; // Bootstrap Icons
// import * as BiIcons from 'react-icons/bi'; // BoxIcons
// import * as CiIcons from 'react-icons/ci'; // Circum Icons
// import * as DiIcons from 'react-icons/di'; // Devicons
// import * as FaIcons from 'react-icons/fa'; // Font Awesome
// import * as FcIcons from 'react-icons/fc'; // Flat Color Icons
// import * as FiIcons from 'react-icons/fi'; // Feather
// import * as GiIcons from 'react-icons/gi'; // Game Icons
// import * as GoIcons from 'react-icons/go'; // Github Octicons
// import * as GrIcons from 'react-icons/gr'; // Grommet-Icons
// import * as HiIcons from 'react-icons/hi'; // HeroIcons
// import * as Hi2Icons from 'react-icons/hi2'; // HeroIcons v2
// import * as ImIcons from 'react-icons/im'; // IcoMoon Free
// import * as IoIcons from 'react-icons/io'; // Ionicons 4
// import * as Io5Icons from 'react-icons/io5'; // Ionicons 5
import * as LuIcons from 'react-icons/lu'; // Lucide Icons
// import * as MdIcons from 'react-icons/md'; // Material Design Icons
// import * as PiIcons from 'react-icons/pi'; // Phosphor Icons
// import * as RiIcons from 'react-icons/ri'; // Remix Icons
// import * as RxIcons from 'react-icons/rx'; // Radix Icons
// import * as SiIcons from 'react-icons/si'; // Simple Icons
// import * as SlIcons from 'react-icons/sl'; // Simple Line Icons
// import * as TbIcons from 'react-icons/tb'; // Tabler Icons
// import * as TfiIcons from 'react-icons/tfi'; // Themify Icons
// import * as TiIcons from 'react-icons/ti'; // Typicons
// import * as VscIcons from 'react-icons/vsc'; // VS Code Icons
// import * as WiIcons from 'react-icons/wi'; // Weather Icons

export const iconPacks = {
	// ai: AiIcons,
	// bs: BsIcons,
	// bi: BiIcons,
	// ci: CiIcons,
	// di: DiIcons,
	// fa: FaIcons,
	// fc: FcIcons,
	// fi: FiIcons,
	// gi: GiIcons,
	// go: GoIcons,
	// gr: GrIcons,
	// hi: HiIcons,
	// hi2: Hi2Icons,
	// im: ImIcons,
	// io: IoIcons,
	// io5: Io5Icons,
	lu: LuIcons,
	// md: MdIcons,
	// pi: PiIcons,
	// ri: RiIcons,
	// rx: RxIcons,
	// si: SiIcons,
	// sl: SlIcons,
	// tb: TbIcons,
	// tfi: TfiIcons,
	// ti: TiIcons,
	// vsc: VscIcons,
	// wi: WiIcons,
};


export const DynamicIcon = ({ onClick, iconName, size = 24, color = 'var(--textColor)' }) => {
	if (!iconName || iconName.length < 3) return null;

	const prefix = iconName.slice(0, 2).toLowerCase();
	const iconPack = iconPacks[prefix];

	if (!iconPack) {
		console.warn(`Pacote de ícones '${prefix}' não encontrado.`);
		return null;
	}

	const IconComponent = iconPack[iconName];

	if (!IconComponent) {
		console.warn(`Ícone '${iconName}' não encontrado no pacote '${prefix}'.`);
		return null;
	}

	return <IconComponent size={size} color={color} onClick={onClick} />;
};